/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PatchedTimeStepSettings
 */
export interface PatchedTimeStepSettings {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly simulationId?: number;
  /**
   * Size of the simulation time step in seconds.
   */
  timeStep?: number;
  /**
   * Minimum size of the simulation time step in seconds. Suitable default is 0.001.
   */
  minTimeStep?: number;
  /**
   * Only in combination with use_time_step_stretch=True.
   */
  maxTimeStep?: number | null;
  /**
   * Permit the time step to increase automatically, when the flow allows it.
   */
  useTimeStepStretch?: boolean;
  /**
   * The interval in seconds in which results are saved to disk.
   */
  outputTimeStep?: number | null;
}

/**
 * Check if a given object implements the PatchedTimeStepSettings interface.
 */
export function instanceOfPatchedTimeStepSettings(value: object): value is PatchedTimeStepSettings {
  return true;
}

export function PatchedTimeStepSettingsFromJSON(json: any): PatchedTimeStepSettings {
  return PatchedTimeStepSettingsFromJSONTyped(json, false);
}

export function PatchedTimeStepSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedTimeStepSettings {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    simulationId: json["simulation_id"] == null ? undefined : json["simulation_id"],
    timeStep: json["time_step"] == null ? undefined : json["time_step"],
    minTimeStep: json["min_time_step"] == null ? undefined : json["min_time_step"],
    maxTimeStep:
      json["max_time_step"] === undefined
        ? undefined
        : json["max_time_step"] === null
        ? null
        : json["max_time_step"],
    useTimeStepStretch:
      json["use_time_step_stretch"] == null ? undefined : json["use_time_step_stretch"],
    outputTimeStep:
      json["output_time_step"] === undefined
        ? undefined
        : json["output_time_step"] === null
        ? null
        : json["output_time_step"],
  };
}

export function PatchedTimeStepSettingsToJSON(json: any): PatchedTimeStepSettings {
  return PatchedTimeStepSettingsToJSONTyped(json, false);
}

export function PatchedTimeStepSettingsToJSONTyped(
  value?: Omit<PatchedTimeStepSettings, "id" | "simulationId"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    time_step: value["timeStep"],
    min_time_step: value["minTimeStep"],
    max_time_step: value["maxTimeStep"],
    use_time_step_stretch: value["useTimeStepStretch"],
    output_time_step: value["outputTimeStep"],
  };
}
